import { actionCreators as projectEditorActionCreators } from "Areas/Projects/projectEditorPanel";
import { buildReduxAccessLevelKey } from "Areas/SharedFeatures/accessLevels/redux/selectors";
import { actionCreators as accessLevelsEditorActionCreators } from "Areas/SharedFeatures/accessLevelsEditorPanel";
import workSpacesActionCreators from "Areas/WorkSpaces/redux/actionCreators";
import { actionCreators as editorActionCreators } from "Areas/WorkSpaces/workSpaceEditorPanel";
import { ACCESS_LEVEL_ENTITY } from "Common/dictionaries/accessLevelEntity";
import { Permissions, security } from "Common/permissions";
import { routesAndPagesMap } from "Common/routingUtils";
import isUndefined from "lodash/isUndefined";
import { connect } from "react-redux";
import routesHash from "../routesMap.hash";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress, getTab, getWorkSpaceId } from "./redux/selectors";
import WorkSpaceDetails from "./workSpaceDetails";
const canViewProjects = security.isAllowed([Permissions.ProjectsView]);
const canEditProjects = security.isAllowed([Permissions.ProjectsEdit]);
const canViewTasks = security.isAllowed([Permissions.TasksView]);
const canEditWorkSpaces = security.isAllowed([Permissions.WorkSpacesEdit]);
const canDeleteWorkSpaces = security.isAllowed([Permissions.WorkSpacesDelete]);
const mapStateToProps = (state) => ({
    workSpaceId: getWorkSpaceId(state),
    inProgress: getInProgress(state),
    data: getData(state),
    tab: getTab(state),
    canViewProjects,
    canViewTasks,
    canEditWorkSpaces,
    canDeleteWorkSpaces,
    canEditProjects
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (workSpaceId) => dispatch(actionCreators.getWorkSpace(workSpaceId)),
    onOpenWorkSpaceEditorPanel: (workSpaceId) => dispatch(editorActionCreators.setWorkSpaceId(workSpaceId)),
    onDeleteWorkSpace: (workSpaceId) => {
        Promise.resolve(dispatch(workSpacesActionCreators.deleteWorkSpace(workSpaceId))).then((promiseResult) => {
            var _a;
            if (isUndefined(promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response))
                return;
            window.location.href =
                (_a = routesAndPagesMap.getPath(routesHash.WELCOME)) !== null && _a !== void 0 ? _a : routesAndPagesMap.getDefaultHref();
        });
    },
    onOpenProjectCreatorPanel: (workSpaceId) => dispatch(projectEditorActionCreators.setNewProject(workSpaceId)),
    onOpenAccessLevelsEditorPanel: (workSpaceId) => dispatch(accessLevelsEditorActionCreators.setAccessLevelsKey(buildReduxAccessLevelKey(workSpaceId, ACCESS_LEVEL_ENTITY.WORKSPACE))),
    onChangeTab: (tab) => dispatch(actionCreators.setTab(tab))
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkSpaceDetails);
